var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detailedView"},_vm._l((_vm.sortedBookingsKeys),function(key,index){return _c('detailed-view-dates-block',{key:index,attrs:{"date":key,"dates":_vm.bookings[key]},on:{"booking-click":function($event){return _vm.$emit('booking-click', $event)},"favorite-click":function($event){return _vm.$emit('favorite-click', {
        ...$event,
        date: key,
      })},"create-booking":function($event){return _vm.$emit('create-booking', { ...$event, date: key })}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }